import { createContext } from "react";
import { type HarvestProduct } from "../utils/types";

export interface HarvestContextType {
  harvestProducts: HarvestProduct[];
  loading: boolean;
  error: string | null;
  fetchHarvestProducts: () => Promise<void>;
  createHarvestProduct: (
    name: string,
    quantity: number,
    price: number,
    discount: number | null
  ) => Promise<void>;
  updateHarvestProduct: (
    id: string,
    quantity: number,
    price: number,
    discount: number | null
  ) => Promise<void>;
  deleteHarvestProduct: (id: string) => Promise<void>;
  refreshHarvestProducts: () => Promise<void>;
  updateHarvestInventory: (array: HarvestProduct[]) => Promise<void>;
}

export const HarvestContext = createContext<HarvestContextType>({
  harvestProducts: [],
  loading: false,
  error: null,
  fetchHarvestProducts: () => Promise.resolve(),
  createHarvestProduct: () => Promise.resolve(),
  updateHarvestProduct: () => Promise.resolve(),
  deleteHarvestProduct: () => Promise.resolve(),
  refreshHarvestProducts: () => Promise.resolve(),
  updateHarvestInventory: () => Promise.resolve(),
});
